/** *************** */
// events
/** *************** */
/** *************** */
// events
/** *************** */
export var BsNavigationDirection;
/** *************** */
// events
/** *************** */
(function (BsNavigationDirection) {
    BsNavigationDirection[BsNavigationDirection["UP"] = 0] = "UP";
    BsNavigationDirection[BsNavigationDirection["DOWN"] = 1] = "DOWN";
})(BsNavigationDirection || (BsNavigationDirection = {}));
//# sourceMappingURL=index.js.map